// Others
import { IPriceBook, IPriceBookDetail } from '~/utils/interface/priceBook';
import { mockMaterials } from './material';

export const mockPriceBooks: IPriceBook[] = [
  {
    id: '1',
    name: 'Noble Standard Price Book',
    totalService: 15,
    totalMaterial: 25,
  },
  {
    id: '2',
    name: 'Noble Premium Price Book',
    totalService: 18,
    totalMaterial: 30,
  },
  {
    id: '3',
    name: 'Noble Basic Price Book',
    totalService: 10,
    totalMaterial: 20,
  },
  {
    id: '4',
    name: 'Noble Custom Price Book',
    totalService: 12,
    totalMaterial: 15,
  },
  {
    id: '5',
    name: 'Noble Enterprise Price Book',
    totalService: 20,
    totalMaterial: 40,
  },
];

export const mockPriceBookDetail: IPriceBookDetail = {
  id: '1',
  name: 'Noble Standard Price Book',
  services: [],
  materials: mockMaterials,
};
